export const privacy = {
  "header": {
    "badge": "Dati personali",
    "title": "politica sulla riservatezza"
  },
  "content": {
    "intro": "La tutela della vostra privacy e dei vostri dati personali è una priorità assoluta per DONKEY TRAVEL. Questa politica descrive in dettaglio come raccogliamo, elaboriamo e proteggiamo le tue informazioni.",
    "collection": {
      "title": "1. Raccolta dati",
      "text": "Raccogliamo solo i dati strettamente necessari per il corretto funzionamento della piattaforma: informazioni sulla creazione del tuo account (cognome, nome, email), collegamenti ai tuoi annunci pubblici (Airbnb) e le tue preferenze di viaggio e disponibilità. Le password sono crittografate e i dati di pagamento vengono elaborati dal nostro partner sicuro Stripe."
    },
    "usage": {
      "title": "2. Utilizzo dei tuoi dati",
      "text": "Le tue informazioni vengono utilizzate per: \n- Verifica la tua idoneità (voto 4.5+) \n- Gestisci il tuo abbonamento \n- Facilitare la connessione con gli altri membri \n- Fornire consigli personalizzati tramite la nostra corrispondenza intelligente \n- Migliorare i nostri servizi e risolvere problemi tecnici."
    },
    "sharing": {
      "title": "3. Condivisione delle informazioni",
      "text": "Non venderemo MAI i tuoi dati personali a terzi. La loro condivisione è strettamente limitata a scopi operativi con i nostri fornitori di servizi di fiducia (web hosting, strumento di pagamento). Al di fuori di questo quadro, i tuoi dati vengono condivisi tra i membri solo per l'organizzazione di uno scambio (e solo l'indirizzo esatto dopo la convalida di uno scambio)."
    },
    "security": {
      "title": "4. Sicurezza",
      "text": "Sono in atto i più robusti protocolli di autenticazione e sicurezza per proteggere i tuoi dati da accessi non autorizzati, alterazioni, divulgazione o distruzione."
    },
    "rights": {
      "title": "5. I tuoi diritti (GDPR)",
      "text": "In conformità con il Regolamento generale sulla protezione dei dati, hai il diritto di accesso, rettifica, portabilità o cancellazione dei tuoi dati personali in qualsiasi momento. Puoi esercitare questo diritto dalle impostazioni del tuo account o scrivendoci a dpo@donkey.travel."
    },
    "cookies": {
      "title": "6. Biscotti",
      "text": "Utilizziamo cookie essenziali per mantenere la tua sessione di accesso, nonché cookie analitici anonimi per capire come viene utilizzato il nostro sito e migliorare la tua esperienza."
    }
  }
};
